"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="héro" className="relative w-full min-h-[45vh] flex flex-col lg:flex-row bg-background overflow-hidden">
      {/* Bloc texte */}
      <div className="w-full flex flex-col justify-center px-6 py-12 z-10 !bg-[#8A9A3A] lg:w-1/2 lg:p-12 xl:p-16">
        <div ref={contentRef} className={`max-w-2xl mx-auto lg:mx-0 transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-tight font-bold mb-4 text-white tracking-tight">
            Certification Qualiopi®&nbsp;: préparez vos audits avec sérénité
          </h1>
          <p className="font-sans text-base md:text-lg mb-8 text-white/90 max-w-xl leading-relaxed">
            Effet Conseil accompagne les organismes prestataires (actions de
            formation, bilans de compétences, VAE, CFA) dans la préparation de
            leurs audits Qualiopi® (initial, surveillance, renouvellement), à
            jour du décret n°&nbsp;2026-728 du 1er&nbsp;août 2026, en rendant le
            Référentiel National Qualité accessible et opérationnel pour vos
            équipes.
          </p>
          <Button asChild size="lg" className="!bg-[hsl(343,80%,35%)] text-white hover:!bg-[hsl(343,80%,30%)] rounded-sm font-sans text-base px-8 py-5 h-auto shadow-xl hover:shadow-2xl transition-all duration-300">
            <a href="https://effet-conseil.com/rdv/">
              Prendre rendez-vous
              <ArrowRight className="ml-2 size-5" />
            </a>
          </Button>
          <p className="font-sans text-sm mt-6 text-white/80">
            Contenu mis à jour le 5&nbsp;octobre 2026
          </p>
        </div>
      </div>

      {/* Bloc image */}
      <div className="w-full lg:w-1/2 relative min-h-[35vh] lg:min-h-[45vh]">
        <img src="https://working-starling.10web.cloud/wp-content/uploads/2026/03/quality_audit.webp" alt="Audit qualité en formation professionnelle" className="absolute inset-0 w-full h-full object-cover object-center blur-[3px]" />
        <div className="hidden lg:block absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#8A9A3A]/20 to-transparent pointer-events-none" />
      </div>
    </section>;
}